import { render, staticRenderFns } from "./PromotionTypesField.vue?vue&type=template&id=7b04587e"
import script from "./PromotionTypesField.vue?vue&type=script&lang=js"
export * from "./PromotionTypesField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports